import React, { Component } from "react";

import fontPaths from "../data/fontPaths.json";

const fontBlacklist = [
  "Aladin-Regular",
  "Alba",
  "Alpha54",
  "Berliner-Wand",
  "BernerBasisschrift1",
  "Berolina",
  "Bitwise",
  "Blankenburg",
  "Bloody",
  "BoecklinsUniverse",
  "BombeCAT",
  "BubblerOne",
  "C-BOX",
  "CariocaScriptPro",
  "Chewy",
  "Classica-Bold",
  "Classica",
  "Courgette",
  "Damion-Regular",
  "Dogv2c",
  "GangOfThree",
  "LetsGoDigital",
  "Megadeth",
  "Nautilus",
  "Niconne",
  "OneTrickPony-OT",
  "PassionOne",
  "Playball",
  "PleasinglyPlump",
  "SpyAgency3",
  "Wolf4b",
  "Wolf4bi",
  "Xenogears",
];

const fonts = [
  "Arimo",
  "DroidSerif",
  "JosefinSans",
  "Mohave",
  "OpenSans",
  "PlayfairDisplay",
  "Quicksand",
  "Tinos",
  "Aladin-Regular",
  "Alba",
  "Alpha54",
  "Berliner-Wand",
  "BernerBasisschrift1",
  "Berolina",
  "Bitwise",
  "Blankenburg",
  "Bloody",
  "BoecklinsUniverse",
  "BombeCAT",
  "BubblerOne",
  "C-BOX",
  "CariocaScriptPro",
  "Chewy",
  "Classica-Bold",
  "Classica",
  "Courgette",
  "Damion-Regular",
  "Dogv2c",
  "GangOfThree",
  "LetsGoDigital",
  "Megadeth",
  "Nautilus",
  "Niconne",
  "OneTrickPony-OT",
  "PassionOne",
  "Playball",
  "PleasinglyPlump",
  "SpyAgency3",
  "Wolf4b",
  "Wolf4bi",
  "Xenogears",
];

export default class ReactFontPicker extends Component {
  render() {
    return (
      <div>
        <ul className="mk-ul">
          <li id="mk-font-box">
            <p id="mk-font-box-inner">{this.props.font}</p>
            <ul className="mk-ul" id="mk-font-list">
              {fonts.map((font, id) => {
                return (
                  <li
                    onClick={() => {
                      this.props.reactFontPicker(font);
                    }}
                    key={id}
                    // className={font.name}
                    id="mk-font-item"
                    style={{
                      fontFamily: fontBlacklist.includes(font)
                        ? font
                        : font + "-Regular",
                      fontSize: "2em",
                    }}
                  >
                    {font}
                  </li>
                );
              })}
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}
